module.exports = __webpack_public_path__ + "static/img/img(40).f536c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(40).png
// module id = 9nzn
// module chunks = 1